import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CategoryBadge } from "./category-badge";
import { Clock, Eye, ArrowLeft } from "lucide-react";
import { SharePopup } from "./share-popup";
import { ReadingProgressBar } from "./reading-progress-bar";
import { api } from "./api";
import "../../../css/blogs.css"; // Add CSS import

const BlogPost = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const fetchBlogPost = async (slug) => {
    try {
      const response = await api.posts.getBySlug(slug);
      setPost(response.post);
    } catch (error) {
      console.error("Failed to fetch blog post:", error);
      setPost(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) {
      fetchBlogPost(slug);
    }
  }, [slug]);

  const formattedDate = post?.createdAt
    ? new Date(post.createdAt).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    : "";

  if (loading) {
    return (
      <div className="blog-post-container">
        <main className="blog-post-loading">
          <div
            style={{
              height: 40,
              width: 40,
              borderTop: "2px solid #3B82F6",
              borderBottom: "2px solid #3B82F6",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
        </main>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-container">
        <main className="blog-post-error">
          <h1
            className="blog-post-title"
            style={{ fontSize: "1.875rem", marginBottom: "1rem" }}
          >
            Blog Post Not Found
          </h1>
          <p style={{ marginBottom: "1.5rem" }}>
            The blog post you're looking for doesn't exist or has been removed.
          </p>
          <Link
            to="/blog"
            className="blog-post-back-link"
            style={{ textDecoration: "underline" }}
          >
            <ArrowLeft
              className="blog-post-meta-icon"
              style={{ height: 16, width: 16 }}
            />
            Back to all posts
          </Link>
        </main>
      </div>
    );
  }

  return (
    <div className="blog-post-container">
      <ReadingProgressBar />
      <main className="blog-post-main-container">
        {" "}
        {/* Use a wrapper class if needed or apply flexGrow to blog-post-main */}
        <article className="blog-post-main">
          <div style={{ marginBottom: "2rem" }}>
            {" "}
            {/* Keep specific margin for now */}
            <Link to="/blog" className="blog-post-back-link">
              <ArrowLeft
                className="blog-post-meta-icon"
                style={{ height: 16, width: 16 }}
              />
              Back to all posts
            </Link>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            {" "}
            {/* Keep specific margin for now */}
            <CategoryBadge category={post.category} />
          </div>

          <h1 className="blog-post-title">{post.title}</h1>

          <div className="blog-post-meta">
            <div className="blog-post-meta-item">
              <Clock size={16} className="blog-post-meta-icon" />
              <span>{formattedDate}</span>
            </div>
            <div className="blog-post-meta-item">
              <Eye size={16} className="blog-post-meta-icon" />
              <span>{post.readTime}</span>
            </div>
          </div>

          <div
            className="blog-post-featured-image-container"
            style={{ height: 300, marginBottom: 40 }}
          >
            {" "}
            {/* Keep specific height/margin for now */}
            {!imageLoaded && <div className="image-loading-shimmer" />}{" "}
            {/* Use existing shimmer class if available or create one */}
            <img
              src={post.featuredImage}
              alt={post.title}
              className="blog-post-featured-image" /* Create this class */
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }} /* Keep object fit inline for now */
              onLoad={() => setImageLoaded(true)}
            />
          </div>

          <div className="blog-post-content">
            <div dangerouslySetInnerHTML={{ __html: post.content }} />
          </div>

          {/* Share Section - Apply classes */}
          <div className="blog-post-share-section">
            <div className="blog-post-share-content">
              <span className="blog-post-share-text">Share this article:</span>
              <SharePopup url={window.location.href} title={post.title} />
            </div>
          </div>
        </article>
      </main>
    </div>
  );
};

export default BlogPost;
